export function scrollTop() {
    let scrollTop = $(".scroll-to-top");
    scrollTop.focus(function () {
        scrollTop.addClass("show");
        if ($("#sliding-popup").length) {
            $("#sliding-popup .popup-content").attr("tabindex", "0");
        }
    }).focusout(function () {
        scrollTop.removeClass("show");
    });

    scrollTop.on("click", function () {
        $(this).removeClass("show");
        $("html, body").animate({scrollTop: 0}, 1000);
        if ($("#sliding-popup").length) {
            setTimeout(function () {
                $("#sliding-popup .popup-content").focus();
            }, 900);
        } else {
            $(".wrapper").attr("tabindex", "0");
            setTimeout(function () {
                $(".wrapper").focus();
            }, 900);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollTop.js